// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from './index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const staffs_router = 'staffs';
const main_router = 'appraisals';
const new_router = 'new_appraisal';
const edit_router = 'edit_appraisal';

const router = [
    {
        path: ':staff_identity',
        component: Index,
        name: 'appraisals',
        meta: {
            api_name: "api_v1_provider_staffs_appraisals",
            breadcrumb: [staffs_router, main_router]
        }
    },
    {
        path: ':staff_identity/new',
        component: New,
        name: 'new_appraisal',
        meta: {
            api_name: "api_v1_provider_appraisal_create",
            breadcrumb: [staffs_router, new_router]
        }
    },
    {
        path: ':staff_identity/:identity/edit',
        component: Edit,
        name: 'edit_appraisal',
        breadcrumb: [staffs_router, edit_router]
    },
]

export default router;
